import React, { useEffect, useState } from "react";
import Select from "react-select";
import { useHistory, useLocation } from "react-router-dom";
import { get, post } from "../../Common/api";
import config from "../../config";
import { useDispatch } from "react-redux";
import { setLoginRedirect } from "../../redux/loginRedirectSlice";

export function ClientSelect() {
  const [validationMessage, setValidationMessage] = useState();
  const [errorMessage, setErrorMessage] = useState();
  const [clientOptions, setClientOptions] = useState([]);
  const [clientId, setClientId] = useState();
  const [loading, setLoading] = useState(true);
  const history = useHistory();
  const { search } = useLocation();
  const queryParams = new URLSearchParams(search);
  const dispatch = useDispatch();
  let returnUrl = queryParams.get("returnUrl");

  useEffect(async () => {
    let mounted = true;
    try {
      setLoading(true);
      const result = await get('/Account/Clients');
      setLoading(false);
      if (result && mounted) {
        if (result.length == 0) {
          history.replace(`${config.loginRoot}?error=access-denied`);
        } else if (result.length == 1) {
          loginToClient(result[0].id);
        } else {
          setClientOptions(result.map(r => ({ label: r.name, value: r.id })));
        }
      } else {
        setErrorMessage(result);
      }
    } catch (error) {
      setLoading(false);
      setErrorMessage(error.message);
    }
    return () => mounted = false;
  },  [])
  const errorMessageClass =
    "alert alert-danger " +
    (errorMessage ? "display-show" : "display-hide");
  const validationSummaryClass = validationMessage
    ? "validation-summary-errors"
    : "validation-summary-valid";
  const goBack = () => history.push(config.loginRoot);
  const title = loading
    ?  "Please wait while we log you in"
    : clientOptions && clientOptions.length > 0
    ? "Please select a client"
    : "Please click the back button to try again"
  const clientSelectStyles = {
    menu: (styles, state) => ({
      ...styles,
      zIndex: 10,
    }),
    placeholder: (styles, state) => ({
      ...styles,
      paddingLeft: "25px",
    }),
    singleValue: (styles, state) => ({
      ...styles,
      paddingLeft: "25px",
    }),
  };
  const selectClient = (option) => {
    const newClientId = option.value
    setClientId(newClientId);
  };
  const loginToClient = async (selectedClientId) => {
    try
    {
      setLoading(true);
      const result = await post(`/Account/OidcLogin?clientId=${selectedClientId}`);
      setLoading(false);
      if (result.status === 'authenticated') {
        // Clear cached left nav so user sees correct menu items
        sessionStorage.removeItem("AdminPortalLeftNav");
        // Begin the user's session (this will log the user in and redirect to home page)
        let url = "/Account/BeginSession";
        // Return to root path if returnUrl is on the login page because
        // it will be very confusing for the user if after they login
        // they end up back on the login page
        returnUrl = (returnUrl && returnUrl.startsWith("/app/login")) ? "/" : returnUrl;
        url += (returnUrl ? `?returnUrl=${encodeURIComponent(returnUrl)}` : '');
        dispatch(setLoginRedirect({
          url: `${config.adminPortalWebsiteOrigin}${url}`,
          message: "Please wait while we log you in"
        }));
        history.push(`${config.loginRoot}/redirect`);
      } else {
        setErrorMessage(result.message);
      }
    } catch (error) {
      setLoading(false);
      setErrorMessage(error.message);
    }
  }
  const login = async () => {
    if (!clientId) {
      setValidationMessage("Please select a client");
    }
    else {
      loginToClient(clientId);
    }
  }
  return (
    <React.Fragment>
      <h4 className="form-title">{title}</h4>
      <div className={errorMessageClass}>
        <button className="close" onClick={() => setErrorMessage()} />
        <span>{errorMessage}</span>
      </div>
      <div className={validationSummaryClass}>
        <ul>{validationMessage ? <li>{validationMessage}</li> : null}</ul>
      </div>{" "}
      <form name="login" key="login">
        {loading ? null : clientOptions.length > 0 ? (
          <React.Fragment>
            <div className="form-group">
              {/*ie8, ie9 does not support html5 placeholder, so we just show field title for that*/}
              <label
                htmlFor="selectClient"
                className="control-label visible-ie8 visible-ie9"
              >
                Organization
              </label>
              <div className="input-icon">
                <i className="fa fa-building" />
                <Select
                  inputId="selectClient"
                  styles={clientSelectStyles}
                  options={clientOptions}
                  onChange={selectClient}
                />
              </div>{" "}
            </div>
            <div className="form-actions">
              <button
                type="button"
                className="btn grey pull-left"
                onClick={() => goBack()}
                aria-label="back"
              >
                Back <i className="m-icon-swapleft m-icon-white" />
              </button>
              <button
                type="button"
                className="btn green pull-right"
                aria-label="login"
                disabled={loading}
                onClick={() => login()}
              >
                Log in
                { loading
                  ? <i className="fa fa-spinner fa-spin" />
                  : <i className="m-icon-swapright m-icon-white" />
                }
              </button>
            </div>{" "}
          </React.Fragment>
        ) : (
          <div className="form-actions">
            <button
              type="button"
              className="btn grey pull-left"
              onClick={() => goBack()}
              aria-label="back"
            >
              Back <i className="m-icon-swapleft m-icon-white" />
            </button>
          </div>
        )}
      </form>
    </React.Fragment>
  );
}
